module.exports = __webpack_public_path__ + "img/arrow-select.f76a0d5e.svg";